// Spoken-language proficiency is stored as a language-neutral code and
// translated to a label in the displayed profile's language.
//
// TRANSITIONAL: until scripts/migrateProfilesToTranslations.js has been run in
// production, profiles and versions may still hold the old English display
// strings, so those are passed through unchanged and kept sortable. Once the
// migration has run, remove LEGACY_LABEL_ORDER, the pass-through in
// getProficiencyLabel, and add an enum of PROFICIENCY_LEVELS to the
// proficiency field in models/Language.js so only codes can be stored.
export const PROFICIENCY_LEVELS = [
  "native",
  "business",
  "conversational",
  "basic",
];

const PROFICIENCY_LABELS = {
  en: {
    native: "Native/fluent",
    business: "Business Proficiency",
    conversational: "Conversational Proficiency",
    basic: "Basic",
  },
  sv: {
    native: "Modersmål/flytande",
    business: "Affärsmässig",
    conversational: "Konversationsnivå",
    basic: "Grundläggande",
  },
};

const LEGACY_LABEL_ORDER = {
  "Native/fluent": 0,
  "Business Proficiency": 1,
  "Conversational Proficiency": 2,
  Basic: 3,
};

export const getProficiencyLabel = (proficiency, language) => {
  if (!proficiency) {
    return "";
  }
  const labels = PROFICIENCY_LABELS[language] || PROFICIENCY_LABELS.en;
  return labels[proficiency] || proficiency;
};

export const getProficiencySortValue = (proficiency) => {
  const index = PROFICIENCY_LEVELS.indexOf(proficiency);
  if (index !== -1) {
    return index;
  }
  if (proficiency in LEGACY_LABEL_ORDER) {
    return LEGACY_LABEL_ORDER[proficiency];
  }
  return PROFICIENCY_LEVELS.length;
};

export const sortLanguagesByProficiency = (languages) =>
  [...(languages || [])].sort(
    (a, b) =>
      getProficiencySortValue(a.proficiency) -
      getProficiencySortValue(b.proficiency)
  );
